// removes all press releases
function removeAllChildNodes(parent) {
	while (parent.firstChild) {
		parent.removeChild(parent.firstChild);
	}
}

// checks how chevrons should appear based on pagination page number
function toggleChevrons(pagenum) {
	const $maxpageel = document.getElementById('maxholder');
	const $maxpages = parseInt($maxpageel.getAttribute('data-maxpages'), 10);

	const chevrons = document.getElementsByClassName('ajax-direction');
	[].forEach.call(chevrons, (elem) => {
		if (!elem.classList.contains('active')) {
			elem.classList.add('active');
		}
	});

	if (pagenum === 0) {
		const $prevEl = document.querySelector('.prev');
		$prevEl.classList.remove('active');
	}

	if (pagenum === $maxpages - 1) {
		const $nextEl = document.querySelector('.next');
		$nextEl.classList.remove('active');
	}
}

const element = document.getElementById('pressreleases');


if (typeof (element) !== 'undefined' && element != null) {
	// pagination for number buttons
	document.addEventListener('click', (event) => {
		if (!event.target.matches('.ajax-trigger')) return;
		event.preventDefault();

		const $pagedata = event.target.getAttribute('data-page');
		const $page = parseInt($pagedata, 10) - 1;
		const $parent = document.getElementById('pressreleases-list');
		const anchor = document.querySelector('#scrollanchor');

		const $paginationholder = document.getElementById('maxholder');
		const $today = $paginationholder.getAttribute('data-today');
		const $twoyears = $paginationholder.getAttribute('data-twoyears');

		const myRequest = new Request(`https://sterlingbancorp2020index.q4web.com/feed/PressRelease.svc/GetPressReleaseList?apiKey=BF185719B0464B3CB809D23926182246&languageId=1&bodyType=1&pageNumber=${$page}&pageSize=10&includeTags=true&pressReleaseDateFilter=2&startDate=${$twoyears}&endDate=${$today}`, {
			method: 'GET',
			crossDomain: true,
		});

		fetch(myRequest)
			.then((response) => response.json()).then((data) => {
				// remove current press releases
				removeAllChildNodes($parent);

				$parent.setAttribute('data-pagenum', $page);

				const pressArray = data.GetPressReleaseListResult;

				// add new press releases from api call to dom
				pressArray.forEach((item) => {
					const str = item.PressReleaseDate;
					const res = str.split(' ');

					$parent.innerHTML = `${$parent.innerHTML}<div class="pressreleases-item"><a href="https://sterlingbancorp.com${item.LinkToDetailPage}" target="_blank"><div class="pressreleases-title">${item.Headline}</div></a><div class="pressreleases-date">Date ${res[0]}</div><div class="pressreleases-desc">${item.ShortDescription}</div><a class="button button--text" href="https://sterlingbancorp.com${item.LinkToDetailPage}" target="_blank">Learn more</a><hr></div>`;
				});

				// scroll to top
				anchor.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});

				// check if Chevrons need to update
				toggleChevrons($page);
			}).catch((err) => {
				// eslint-disable-next-line no-console
				console.warn('API call error', err);
			});
	}, false);


	// pagination for chevron buttons
	document.addEventListener('click', (event) => {
		if (!event.target.matches('.ajax-direction')) return;
		event.preventDefault();

		const anchor = document.querySelector('#scrollanchor');
		const $parent = document.querySelector('.pressreleases-list');
		const $pagedirection = event.target.getAttribute('data-direction');
		const $currpage = $parent.getAttribute('data-pagenum');
		let $page;

		const $paginationholder = document.getElementById('maxholder');
		const $today = $paginationholder.getAttribute('data-today');
		const $twoyears = $paginationholder.getAttribute('data-twoyears');

		if ($pagedirection === 'next') {
			$page = parseInt($currpage, 10) + 1;
		}

		if ($pagedirection === 'prev') {
			$page = parseInt($currpage, 10) - 1;
		}

		const myRequest = new Request(`https://sterlingbancorp2020index.q4web.com/feed/PressRelease.svc/GetPressReleaseList?apiKey=BF185719B0464B3CB809D23926182246&languageId=1&bodyType=1&pageNumber=${$page}&pageSize=10&includeTags=true&pressReleaseDateFilter=2&startDate=${$twoyears}&endDate=${$today}`, {
			method: 'GET',
			crossDomain: true,
		});

		fetch(myRequest)
			.then((response) => response.json()).then((data) => {
				removeAllChildNodes($parent);

				$parent.setAttribute('data-pagenum', $page);

				const pressArray = data.GetPressReleaseListResult;

				pressArray.forEach((item) => {
					const str = item.PressReleaseDate;
					const res = str.split(' ');

					$parent.innerHTML = `${$parent.innerHTML}<div class="pressreleases-item"><a href="https://sterlingbancorp.com${item.LinkToDetailPage}" target="_blank"><div class="pressreleases-title">${item.Headline}</div></a><div class="pressreleases-date">Date ${res[0]}</div><div class="pressreleases-desc">${item.ShortDescription}</div><a class="button button--text" href="https://sterlingbancorp.com${item.LinkToDetailPage}" target="_blank">Learn more</a><hr></div>`;
				});

				anchor.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});

				toggleChevrons($page);
			}).catch((err) => {
				// eslint-disable-next-line no-console
				console.warn('API call error', err);
			});
	}, false);
}
